<template>
  <div class="row">
    <div class="col-12 g c" v-if="!loading">
        <div class="card card-body">
            <div class="alert alert-success g" v-if="orders.length == 0">
                كل شيئ جيد!
            </div>
            <div class="col-12 table-responsive">
                <table class="table table-hover table-bordered table-striped table-sm">
                    <thead>
                        <th>
                            الخدمة
                        </th>
                        <th>
                            الطلب
                        </th>
                        <th>
                            الطلب
                        </th>
                        <th>
                            التاريخ
                        </th>
                        <th>
                            في خدماتنا
                        </th>
                        <th>
                            في ميسر
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="order in orders" :key="order._id">
                            <td>
                                {{ order.service }}
                            </td>
                            <td>
                                {{ order.m_order_id ? order.m_order_id : order.order_id }}
                            </td>
                            <td>
                                {{ order.order_id }}
                            </td>
                            <td>
                                {{ order.date }}
                            </td>
                            <td>
                                <span class="text-success">
                                    <i class="fa fa-check"></i>
                                    موجود
                                </span>
                            </td>
                            <td>
                                <span class="text-danger" v-if="!order.m_order_id || order.m_order_id == '' || !order.morder">
                                    <i class="fa fa-times"></i>
                                    غير
                                    موجود طلب
                                </span>
                                <span v-if="order.morder">
                                    <span class="text-danger" v-if="order.morder.status != 'paid'">
                                        <i class="fa fa-times"></i>
                                        الطلب غير مدفوع {{ order.morder.status }}
                                    </span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
var XLSX = require("xlsx");
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            orders: [],
            loading: false
        }
    },
    created(){
        var g = this;
        g.view()
    },
    methods: {
        view(){
            var g = this;
            g.loading = true;
            $.post(api + '/user/apps/morders', {
                jwt: g.user.jwt
            }).then(function(r){
                g.orders = r.response
                g.loading = false;
            }).fail(function(){
                alert('Error')
            })
        },
    }
}
</script>

<style>

</style>